import { usePlaceLookupWithListingStats } from '@hcs/places';
import { DateStr } from '@hcs/types';

import { placeLookupListingStatsTSToCerberusListingStats } from '../utils';

export const useCityListingStatsTimeSeries = ({
  placeId,
  fromDate,
  toDate,
  propertyType,
}: {
  placeId: string | null | undefined;
  fromDate?: DateStr;
  toDate?: DateStr;
  enabled?: boolean;
  propertyType: 'singleFamily' | 'condo';
}) => {
  const response = usePlaceLookupWithListingStats({
    placeId,
    fromDate,
    toDate,
  });
  return {
    ...response,
    data: response.data
      ? placeLookupListingStatsTSToCerberusListingStats(
          response.data,
          propertyType,
        )
      : null,
  };
};
